import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";
import type { WireEvent } from "@watchover/shared";

/** Report Core Web Vitals as performance events. Each fires at most once. */
export function captureWebVitals(emit: (e: WireEvent) => void) {
  const report = (metric: string) => (m: { value: number }) =>
    emit({ t: "performance", ts: Date.now(), metric, value: m.value });
  try {
    onLCP(report("LCP"));
    onCLS(report("CLS"));
    onINP(report("INP"));
    onFCP(report("FCP"));
    onTTFB(report("TTFB"));
  } catch {
    /* web-vitals unsupported — skip */
  }
}

/** Capture uncaught errors and unhandled promise rejections. */
export function captureErrors(emit: (e: WireEvent) => void): () => void {
  const onError = (e: ErrorEvent) => {
    emit({
      t: "error",
      ts: Date.now(),
      message: e.message || "script error",
      source: e.filename,
      line: e.lineno,
      col: e.colno,
      stack: e.error?.stack ? String(e.error.stack).slice(0, 4000) : undefined,
    });
  };
  const onRejection = (e: PromiseRejectionEvent) => {
    const reason: any = e.reason;
    emit({
      t: "error",
      ts: Date.now(),
      message:
        (reason && (reason.message || String(reason))) || "unhandled rejection",
      stack: reason?.stack ? String(reason.stack).slice(0, 4000) : undefined,
    });
  };
  window.addEventListener("error", onError, true);
  window.addEventListener("unhandledrejection", onRejection, true);
  return () => {
    window.removeEventListener("error", onError, true);
    window.removeEventListener("unhandledrejection", onRejection, true);
  };
}
